import { render, staticRenderFns } from "./BrigListDelButton.vue?vue&type=template&id=3034e351&scoped=true&"
import script from "./BrigListDelButton.vue?vue&type=script&lang=js&"
export * from "./BrigListDelButton.vue?vue&type=script&lang=js&"
import style0 from "./BrigListDelButton.vue?vue&type=style&index=0&id=3034e351&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3034e351",
  null
  
)

export default component.exports